<template lang="pug">
    div(
        v-if="price >= 5000"
        :class="{ 'text-center': alignment === 'center', 'text-left': alignment === 'left' }"
        :data-page-type="pageType"
        :data-amount="price"
        class="affirm-as-low-as text-gray-dark text-sm font-normal py-2"
    )
</template>

<script>
/**
 * Affirm Refresh logic for this component is being handled in the Vue Router index.js file
 * This component is used multiple times on a single page so the logic would get duplicated
 * if we placed it here.
 */
import { refreshAffirm } from './refreshAffirm'

export default {
    name: 'AffirmAsLowAs',
    props: {
        price: {
            type: Number,
            default: 0,
        },
        pageType: {
            type: String,
            required: true,
            validator: (value) => {
                // Only accepts values that contain the string 'cookie-dough'.
                return value === 'product' || value === 'cart'
            },
        },
        alignment: {
            type: String,
            default: 'center',
            validator: (value) => {
                // Only accepts values that contain the string 'cookie-dough'.
                return value === 'center' || value === 'left'
            },
        },
    },
    watch: {
        price() {
            this.refreshAffirm()
        },
    },
    mounted() {
        this.$affirm.load()
        this.refreshAffirm()
    },
    methods: {
        refreshAffirm,
    },
}
</script>

<style lang="stylus" scoped>
.affirm-as-low-as
    >>> .affirm-ala-price
        font-weight: theme('fontWeight.bold')
    >>> .__affirm-logo
        font-size: theme('fontSize.base')
    >>> .affirm-modal-trigger
        color: theme('colors.gray.dark')
        font-weight: theme('fontWeight.bold')
        text-decoration: underline
        font-size: theme('fontSize.xs')
        white-space: nowrap
</style>
